import { type ComponentProps } from "react";
import { VisuallyHidden } from "react-aria";
import {
  CoreButtonAlt,
  type PropsWithOptionalTestID,
} from "@boi/components-core";
import { useDesignTokens } from "@boi/react-design-tokens";

import * as S from "./ButtonGroupItem.styled";

export type ButtonGroupItemProps = PropsWithOptionalTestID &
  Pick<ComponentProps<"input">, "name" | "value" | "checked" | "onChange"> & {
    label: string;
    hasError?: boolean;
    fullWidth?: boolean;
    textAlign?: CoreButtonAlt.TextAlign;
    typographyVariant?: CoreButtonAlt.TypographyVariant;
  };

function ButtonGroupItem(props: ButtonGroupItemProps) {
  const {
    label,
    hasError = false,
    fullWidth = false,
    textAlign = CoreButtonAlt.DEFAULT_TEXT_ALIGN,
    typographyVariant = CoreButtonAlt.DEFAULT_TYPOGRAPHY_VARIANT,
    testID = "button-group-item",
    ...inputProps
  } = props;

  const { tokens } = useDesignTokens();
  const { buttonAlt } = tokens;

  return (
    <S.Container
      $hasError={hasError}
      $fullWidth={fullWidth}
      $textAlign={textAlign}
      data-testid={`${testID}-item`}
    >
      <VisuallyHidden>
        <input {...inputProps} type="radio" aria-label={label} />
      </VisuallyHidden>

      <S.Text
        color="inherit"
        variant={typographyVariant}
        fontFamily={buttonAlt.typography.fontFamily}
        component="span"
        aria-hidden
      >
        {label}
      </S.Text>
    </S.Container>
  );
}

export default ButtonGroupItem;
